/*Package importing*/
import React, { Component } from 'react';

/*Components*/
import Inputs from '../../components/formComponents/inputs.js';
import DateRange from '../../components/dateRangePicker/dateRange.js';
import SelectBox from '../../components/formComponents/selectBox';



/*Assets*/
import SampleAd from '../../assets/images/sample1.png';


class ViewSampleModal extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }
   selectChange = async (category) => {
    await this.setState({category: category});
  }


  componentDidMount() {

  }

  render() {

    return (
      <div className="modal fade e-ad-detail-wrap e-ofer-modal" id="sample" tabIndex="-1" role="dialog" aria-labelledby="sampleModalLabel" aria-hidden="true">
        <div className="modal-dialog e-sample-ad-modal"  role="document">
          <div className="modal-content e-ofer e-purchase-modal">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <img src={SampleAd} className="e-sample-ad" alt="Offer Banner"/>
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-lg-7">
                <div className="e-smaple-modal-content">
                  <h6 className="pt-3">*Note</h6>
                  <p>- The slider banner section in the online home page</p>
                  <p>- The slider banner section in the online home page</p>
                  <p>- The slider banner section in the online home page</p>
                  <p>- The slider banner section in the online home page</p>
                </div>
              </div>
            </div>

            <div className="modal-footer">

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewSampleModal;
